import '@/teams/portfolio/components/section/home-section/ai-indicator/tech-stack/tech-stack.scss'

interface TechStackProps {
	className?: string
}

const TECHNOLOGIES = [
	'React',
	'TypeScript',
	'Rust',
	'Kubernetes',
	'AI',
	'Ubuntu',
] as const

export function TechStack({ className }: Readonly<TechStackProps>) {
	const classes = ['tech-stack', className].filter(Boolean).join(' ')

	return (
		<div className={classes} data-testid='tech-stack'>
			<div className='tech-stack__pills'>
				{TECHNOLOGIES.map((tech) => (
					<span
						className='tech-stack__pill'
						data-testid={`tech-stack__pill-${tech.toLowerCase()}`}
						key={tech}>
						{tech}
					</span>
				))}
			</div>
		</div>
	)
}
